// extracted by mini-css-extract-plugin
export default {"not_allowed":"not-allowed_not_allowed__zNDV3"};